module.exports = __webpack_public_path__ + "static/dependencies-c1e6afe03397ec033a7869f25b9a21fa.png";